import React from 'react';
import { withTranslation } from '../../ChildrenContext.js';
import PropTypes from 'prop-types';
import StatisticsByCreativeContentComponent from './StatisticsByCreativeContent/StatisticsByCreativeContent.container';
import { withRouter } from '../../RouterCompatibility.js';

const StatisticsByCreativePage = ({ location, t }) => {
    const staticNames = t?.reportPage || {};

    return (
        <div className="dashboard dashboard_consolidated-report">
            <div className="page-heading">
                <div className="page-heading__inner">
                    <h2>{staticNames.titleByCreative}</h2>
                </div>
            </div>

            <StatisticsByCreativeContentComponent
                location={location}
            />
        </div>
    );
};

StatisticsByCreativePage.propTypes = {
    location: PropTypes.object,
    t: PropTypes.object
};

StatisticsByCreativePage.defaultProps = {
    location: {},
    t: {}
};

export default withRouter(withTranslation(StatisticsByCreativePage));